import { render, staticRenderFns } from "./CardInfoModal.vue?vue&type=template&id=21b632e8&scoped=true&"
import script from "./CardInfoModal.vue?vue&type=script&lang=js&"
export * from "./CardInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoModal.vue?vue&type=style&index=0&id=21b632e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b632e8",
  null
  
)

export default component.exports